import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  loadInventoryByPlant,
  loadInventoryByPlantFailure,
  loadInventoryByPlantSuccess,
} from './inventory-by-plant.actions';
import { InventoryByPlantApiService } from './inventory-by-plant.api.service';

@Injectable()
export class InventoryByPlantEffects {
  constructor(
    private actions$: Actions,
    private api: InventoryByPlantApiService,
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInventoryByPlant),
      mergeMap((action) =>
        this.api.getInventory(action.productCode, action.plants).pipe(
          map((data) => loadInventoryByPlantSuccess({ key: action.key, data })),
          catchError((error) => of(loadInventoryByPlantFailure({ key: action.key, error }))),
        ),
      ),
    ),
  );
}
